// extracted by mini-css-extract-plugin
module.exports = {"container":"_34I0qp8HDIxS0Dqllbkb8v"};